import { render, staticRenderFns } from "./modal-event-system.vue?vue&type=template&id=ce4ab604&scoped=true"
import script from "./modal-event-system.vue?vue&type=script&lang=js"
export * from "./modal-event-system.vue?vue&type=script&lang=js"
import style0 from "./modal-event-system.vue?vue&type=style&index=0&id=ce4ab604&prod&lang=scss"
import style1 from "./modal-event-system.vue?vue&type=style&index=1&id=ce4ab604&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4ab604",
  null
  
)

export default component.exports